"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeySystemOptionsManager = (function () {
    function KeySystemOptionsManager(keySystemOptionsGenerators) {
        this.keySystemOptionsGenerators = keySystemOptionsGenerators;
    }
    KeySystemOptionsManager.prototype.getAllKeySystemOptions = function (drmConfiguration) {
        if (!drmConfiguration) {
            return [];
        }
        return this.keySystemOptionsGenerators
            .map(function (keySystemOptionsGenerator) { return keySystemOptionsGenerator.getKeySystemOptions(drmConfiguration); })
            .filter(function (x) { return Boolean(x); });
    };
    return KeySystemOptionsManager;
}());
exports.default = KeySystemOptionsManager;
